import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';
import { SocialCoin } from '../SocialCoin/SocialCoin';
import { SweepCoin } from '../SweepCoin/SweepCoin';

export const CoinImage = observer(function CoinImage(props: { className?: string; color?: 'green' | 'yellow' }) {
  const { className, color } = props;

  const { coinTypeStore } = useStores();

  const coinColor = color ? color : coinTypeStore.coinType === 'GC' ? 'yellow' : 'green';

  return coinColor === 'yellow' ? <SocialCoin className={className} /> : <SweepCoin className={className} />;
});
